import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.TranslationLanguages;

export const statusSelector = createSelector(rootSelector, (stations) => stations.status);

export const errorSelector = createSelector(rootSelector, (stations) => stations.error);

export const translationLanguagesSelector = createSelector(rootSelector, (state) => {
  return state.data ? state.data : [];
});

export const translationLanguageCodesSelector = createSelector(rootSelector, (state) => {
  return state.data ? state.data.map((item) => item.code) : [];
});

export default {
  statusSelector,
  errorSelector,
  translationLanguagesSelector,
  translationLanguageCodesSelector,
};
